var _rect, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCohortEdit(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 33,
    viewBox: "0 0 32 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.793945,
    width: 32,
    height: 32,
    rx: 16,
    fill: "#F0F0F0"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 22.7939H22M17.1896 12.3351C17.1896 12.3351 17.1896 13.4248 18.2794 14.5146C19.3691 15.6043 20.4589 15.6043 20.4589 15.6043M12.8798 20.786L15.1682 20.4591C15.4983 20.4119 15.8042 20.259 16.04 20.0232L21.5486 14.5146C22.1505 13.9127 22.1505 12.9369 21.5486 12.3351L20.4589 11.2453C19.857 10.6435 18.8812 10.6435 18.2794 11.2453L12.7708 16.7539C12.535 16.9897 12.382 17.2956 12.3349 17.6257L12.008 19.9142C11.9353 20.4227 12.3712 20.8586 12.8798 20.786Z",
    stroke: "#868687",
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCohortEdit);
export default __webpack_public_path__ + "static/media/cohort_edit.ba14e8d47f1c82d7d7ed9eb05cb68aaf.svg";
export { ForwardRef as ReactComponent };